import React, { useState } from 'react'
import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'
import VideoManager from '../components/VideoManager'
import PromoSitesManager from '../components/PromoSitesManager'
import SettingsManager from '../components/SettingsManager'
import { Footer } from '../components/Footer'
import logoImg from '../assets/images/logo_flag.png'
import { Image } from '@chakra-ui/react'

const AdminPage = () => {
  const { currentUser, logout } = useAuth()
  const [activeTab, setActiveTab] = useState(0)

  const handleLogout = async () => {
    const result = await logout()
    if (result.success) {
      window.location.href = '/'
    }
  }

  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="gray.50">
      <Box
        as="header"
        position="sticky"
        top={0}
        zIndex={50}
        w="100%"
        bg="white"
        borderBottom="1px solid"
        borderColor="gray.200"
      >
        <Box maxW="1280px" mx="auto" px={{ base: 4, sm: 6 }} py={4}>
          <Flex
            flexDirection={{ base: 'column', sm: 'row' }}
            alignItems={{ base: 'stretch', sm: 'center' }}
            justifyContent="space-between"
            gap={4}
          >
            <Flex alignItems="center" gap={3}>
              <Box
                w={8}
                h={8}
                borderRadius="lg"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bg="white"
                boxShadow="sm"
                border="1px solid"
                borderColor="gray.200"
              >
                <Image
                  src={logoImg}
                  alt="EXCELLO"
                  w={5}
                  h={5}
                  objectFit="contain"
                />
              </Box>
              <Box>
                <Heading as="h1" size="lg" color="gray.900" mb={0}>
                  관리자 대시보드
                </Heading>
                <Text fontSize="sm" color="gray.600">
                  YouTube 비디오 · 홍보페이지 관리
                </Text>
              </Box>
            </Flex>
            <Flex alignItems="center" gap={4}>
              <Text fontSize="sm" color="gray.500" noOfLines={1} maxW="200px">
                로그인: {currentUser?.email}
              </Text>
              <Button
                size="sm"
                colorScheme="red"
                onClick={handleLogout}
                _hover={{ bg: 'red.600' }}
              >
                로그아웃
              </Button>
            </Flex>
          </Flex>
        </Box>
      </Box>

      <Box
        flex={1}
        maxW="1280px"
        w="100%"
        mx="auto"
        px={{ base: 4, sm: 6 }}
        py={6}
      >
        <Box
          bg="white"
          borderRadius="xl"
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.200"
          overflow="hidden"
        >
          <Tabs index={activeTab} onChange={setActiveTab}>
            <TabList
              borderBottom="1px solid"
              borderColor="gray.200"
              px={{ base: 4, sm: 6 }}
            >
              <Tab
                _selected={{
                  color: 'blue.600',
                  borderColor: 'blue.500',
                  fontWeight: 'semibold',
                }}
                color="gray.500"
                borderBottom="2px solid"
                borderColor="transparent"
                fontSize="sm"
                fontWeight="medium"
                py={4}
                px={2}
                mr={{ base: 2, sm: 4 }}
              >
                YouTube 비디오 관리
              </Tab>
              <Tab
                _selected={{
                  color: 'blue.600',
                  borderColor: 'blue.500',
                  fontWeight: 'semibold',
                }}
                color="gray.500"
                borderBottom="2px solid"
                borderColor="transparent"
                fontSize="sm"
                fontWeight="medium"
                py={4}
                px={2}
                mr={{ base: 2, sm: 4 }}
              >
                재생 설정
              </Tab>
              <Tab
                _selected={{
                  color: 'blue.600',
                  borderColor: 'blue.500',
                  fontWeight: 'semibold',
                }}
                color="gray.500"
                borderBottom="2px solid"
                borderColor="transparent"
                fontSize="sm"
                fontWeight="medium"
                py={4}
                px={2}
              >
                홍보페이지 관리
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel p={0}>
                <VideoManager />
              </TabPanel>
              <TabPanel p={0}>
                <SettingsManager />
              </TabPanel>
              <TabPanel p={0}>
                <PromoSitesManager />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>

      <Footer />
    </Box>
  )
}

export default AdminPage
